import { DataLayer } from '../lib/dataLayer'

// One-time fix for cards with 100% mastery that aren't marked as mastered
export async function fixMasteryStatus(userId: string) {
  console.log('[FixMasteryStatus] Checking for cards with 100% mastery...')
  
  const progress = await DataLayer.getUserCardProgress(userId)
  let fixedCount = 0
  
  for (const p of progress) {
    if (p.mastery_score === 100 && p.status !== 'mastered') {
      console.log(`[FixMasteryStatus] Fixing card ${p.card_id} - setting status to mastered`)
      
      await DataLayer.upsertUserCardProgress({
        ...p,
        status: 'mastered',
        updated_at: new Date().toISOString()
      })
      
      fixedCount++
    }
  }
  
  if (fixedCount > 0) {
    console.log(`[FixMasteryStatus] Fixed ${fixedCount} cards with 100% mastery`)
  } else {
    console.log('[FixMasteryStatus] No cards needed fixing')
  }
}